const translations = {
  "en": {
    "Portfolio Tracker": "Portfolio Tracker",
    "The report will be generated at 8:00am": "The report will be generated at 8:00am"
  },
  "zh-tw": {
    "Portfolio Tracker": "投資組合追蹤",
    "The report will be generated at 8:00am": "報告將於上午 8:00 生成"
  }
};

export default translations;
